import React, { Component } from 'react';

import {Rest} from "../../Helpers/Rest"

import { Container, Row, Col, Button} from 'react-bootstrap';
import Form from "../../Components/Form/Form"
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
export default class Authentification extends Component {
  state = {}

  login = () =>{
    this.setState({
      errors: false
    })
    var rest = new Rest(this)
    rest.login(this.state.login, this.state.password, (res)=>{
       

      if(res.token){
        var data = {
          token: res.token,
          login: res.login
        }
        localStorage.setItem( "user_data", JSON.stringify(data) )
        document.location.href = "/"
        setTimeout(()=>{ 
            document.location.reload()
        }, 500)
      }

    })
  }

  render() {
    console.log(this.state)
    return (
      <Container>
        

        <Row className="mt-3 center">
            <Col>
                <Row className="d-flex justify-content-center">
                    <Col className="text-center">
                    <h4>Please, enter your login and password</h4>
                    </Col>
                </Row>
                
            </Col>
        </Row>

        {
          this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
        }



        <Row className="mt-3 center">
            <Col>
                <Row className="d-flex justify-content-center">
                    <Col xl={3} lg={4}>
                        <Form
                            fields = {
                              [
                                {
                                  name: "login",
                                  label: "Login"
                                },
                                {
                                  name: "password",
                                  label: "Password",
                                  type: "password"
                                }
                              ]
                            }
                            store_to={"state"}
                            _this = {this}
                        />

                        <Button className="btn-block" variant="dark" onClick={this.login}>
                            Enter
                        </Button>
                    </Col>
                </Row> 
            </Col>
        </Row>
         
      </Container>
    );
  }
}
